import { TableCell, TableRow, Typography } from '@mui/material';
import { renderRowCreatedAt } from 'src/utils/renderTableCell';

export const CourseParticipantsTableRow = ({ row, index, actions }) => {
  const { user, course, currentScore, createdAt } = row;

  return (
    <>
      <TableRow key={index} hover>
        <TableCell align="left">
          <Typography variant="body2">{index + 1}</Typography>
        </TableCell>
        <TableCell align="center">
          <Typography variant="body1" fontWeight={700}>
            {user?.name || '-'}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography variant="body2" fontWeight={400}>
            {user?.info?.mobile || '-'}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography variant="body1" fontWeight={400}>
            {user?.userLevel?.levelName || '-'}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography variant="body1" fontWeight={400}>
            {course?.title || '-'}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography variant="body1" fontWeight={400}>
            {course?.category?.name || '-'}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography variant="body1" fontWeight={400}>
            {course?.totalScore || 0}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography variant="body1" fontWeight={400}>
            {currentScore || 0}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography variant="body1" fontWeight={400}>
            {renderRowCreatedAt('fa-IR', createdAt) || '-'}
          </Typography>
        </TableCell>
      </TableRow>
    </>
  );
};
